/* Copyright (c) 2018 Scaper */

import { APP_PATH } from "../appPath";

export const PAYMENT_PATH = `${APP_PATH}/payment`;
